import { useT } from "../i18n";
import Amount from "./Amount";

export default function CreditMeter({
  available,
  reserved,
  spent,
  total,
}: {
  available: number;
  reserved: number;
  spent: number;
  total: number;
}) {
  const t = useT();
  const safeTotal = Math.max(total, 1);
  const spentWidth = Math.min(100, (spent / safeTotal) * 100);
  const reservedWidth = Math.min(100 - spentWidth, (reserved / safeTotal) * 100);
  return (
    <div className="credit-meter-wrap">
      <div className="credit-meter" aria-label={t("meter.label", { available, total })}>
        <span className="meter-spent" style={{ width: `${spentWidth}%` }} />
        <span className="meter-reserved" style={{ width: `${reservedWidth}%` }} />
      </div>
      <div className="meter-legend">
        {/* Amount, so the figure and its word stay together in Arabic. */}
        <span><i className="legend-dot spent" /><Amount value={spent} /> {t("meter.spent")}</span>
        <span><i className="legend-dot reserved" /><Amount value={reserved} /> {t("meter.reserved")}</span>
        <span><i className="legend-dot available" /><Amount value={available} /> {t("meter.available")}</span>
      </div>
    </div>
  );
}
